import React, { useEffect, useState } from "react";
import { Modal, Button, Table, Tabs, Tab } from "react-bootstrap";
import Swal from "sweetalert2";
import html2pdf from "html2pdf.js";

import Headerimg from "../../../utils/header.jpeg";
import Footerimg from "../../../utils/footer.jpeg";
import { PencilSquare } from "react-bootstrap-icons";

import {
  getEvolucionesByPaciente,
  getMedicacionesbyPaciente,
  getInsumoUsadobyPaciente,
  getSignosVitalesbyPaciente,
} from "../../../api/EvolucionApi";
import {
  updateEvolucion,
  updateMedicacion,
  updateInsumo,
  updateSignosVitales,
} from "../../../api/EvolucionApi";

/* ===================== HELPERS ===================== */
function normalizeClinicalText(text) {
  if (!text) return "";
  return text.replace(/%bp/gi, "\n").replace(/\n\s*/g, "\n").trim();
}

function chunkArray(array, size) {
  const res = [];
  for (let i = 0; i < array.length; i += size) {
    res.push(array.slice(i, i + size));
  }
  return res;
}

/* ===================== FILTROS ===================== */
function filtrarPorFecha(array, campoFecha, desde, hasta) {
  if (!desde && !hasta) return array;

  return array.filter((item) => {
    if (!item[campoFecha]) return false;

    const fechaItem = new Date(item[campoFecha].split(" ")[0]);
    const fDesde = desde ? new Date(desde) : null;
    const fHasta = hasta ? new Date(hasta) : null;

    if (fDesde && fechaItem < fDesde) return false;
    if (fHasta && fechaItem > fHasta) return false;

    return true;
  });
}

function filtrarPorProfesional(array, campo, texto) {
  if (!texto) return array;

  return array.filter((item) =>
    (item[campo] || "").toLowerCase().includes(texto.toLowerCase())
  );
}

/* ===================== ESTILOS PDF ===================== */
const pageStyle = {
  width: "210mm",
  height: "295mm",
  position: "relative",
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: "12px",
  color: "#000",
  background: "#fff",
  boxSizing: "border-box",
};

const headerStyle = { height: "32mm" };

const footerStyle = {
  height: "25mm",
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
};

const contentStyle = {
  padding: "6mm 15mm 28mm 15mm",
};

/* ===================== EXPORT PDF ===================== */
function exportarHTML(id, filename) {
  const el = document.getElementById(id);
  if (!el) {
    Swal.fire("Error", "No se pudo generar el PDF", "error");
    return;
  }

  html2pdf()
    .from(el)
    .set({
      margin: 0,
      filename,
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      pagebreak: { mode: ["css"] },
    })
    .save();
}

/* ===================== COMPONENTE ===================== */
const ModalHojaEnfermeria = ({
  estado,
  onCloseModal,
  idpaciente,
  nombrePaciente,
}) => {
  const [evoluciones, setEvoluciones] = useState([]);
  const [medicaciones, setMedicaciones] = useState([]);
  const [insumos, setInsumos] = useState([]);
  const [signos, setSignos] = useState([]);

  const [fechaDesde, setFechaDesde] = useState("");
  const [fechaHasta, setFechaHasta] = useState("");
  const [filtroProfesional, setFiltroProfesional] = useState("");
const [showEditModal, setShowEditModal] = useState(false);
const [registroEditando, setRegistroEditando] = useState(null);
const [tipoRegistro, setTipoRegistro] = useState("");
const guardarEdicion = async () => {
  try {
    Swal.fire({
      title: "Actualizando...",
      allowOutsideClick: false,
      showConfirmButton: false,
    });

    if (tipoRegistro === "evolucion") {
      await updateEvolucion(registroEditando.idevolucion, {
        texto: registroEditando.texto,
      });

      setEvoluciones((prev) =>
        prev.map((e) =>
          e.idevolucion === registroEditando.idevolucion ? registroEditando : e
        )
      );
    }

    if (tipoRegistro === "medicacion") {
      await updateMedicacion(registroEditando.idmedicacion, registroEditando);
      setMedicaciones((prev) =>
        prev.map((m) =>
          m.idmedicacion === registroEditando.idmedicacion ? registroEditando : m
        )
      );
    }

    if (tipoRegistro === "insumo") {
      await updateInsumo(registroEditando.idinsumo, registroEditando);
      setInsumos((prev) =>
        prev.map((i) =>
          i.idinsumo === registroEditando.idinsumo ? registroEditando : i
        )
      );
    }

    if (tipoRegistro === "signos") {
      await updateSignosVitales(registroEditando.id, registroEditando);
      setSignos((prev) =>
        prev.map((s) =>
          s.id === registroEditando.id ? registroEditando : s
        )
      );
    }

    Swal.close();
    setShowEditModal(false);
  } catch (err) {
    Swal.fire("Error", "No se pudo actualizar", "error");
  }
};

  useEffect(() => {
    if (!estado) return;

    const fetchData = async () => {
      try {
        Swal.fire({
          title: "Cargando Hoja de Enfermería...",
          allowOutsideClick: false,
          showConfirmButton: false,
        });

        const [ev, med, ins, sig] = await Promise.all([
          getEvolucionesByPaciente(idpaciente),
          getMedicacionesbyPaciente(idpaciente),
          getInsumoUsadobyPaciente(idpaciente),
          getSignosVitalesbyPaciente(idpaciente),
        ]);

        setEvoluciones(ev);
        setMedicaciones(med);
        setInsumos(ins);
        setSignos(sig);

        Swal.close();
      } catch {
        Swal.fire("Error", "No se pudo cargar la hoja", "error");
      }
    };

    fetchData();
  }, [estado, idpaciente]);

  /* ===================== ARRAYS FILTRADOS ===================== */
  const evolucionesFiltradas = filtrarPorProfesional(
    filtrarPorFecha(evoluciones, "fechahora", fechaDesde, fechaHasta),
    "profesional",
    filtroProfesional
  );

  const medicacionesFiltradas = filtrarPorProfesional(
    filtrarPorFecha(medicaciones, "fechaRegistro", fechaDesde, fechaHasta),
    "Profesional",
    filtroProfesional
  );

  const insumosFiltrados = filtrarPorProfesional(
    filtrarPorFecha(insumos, "fechahora", fechaDesde, fechaHasta),
    "profesional",
    filtroProfesional
  );

  const signosFiltrados = filtrarPorProfesional(
    filtrarPorFecha(signos, "fechahora", fechaDesde, fechaHasta),
    "profesional",
    filtroProfesional
  );

  return (
    <>
      <Modal show={estado} onHide={onCloseModal} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>Hoja de Enfermería</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* BOTONES PDF */}
          <div className="d-flex gap-2 mb-3 flex-wrap">
            <Button onClick={() => exportarHTML("pdf-evoluciones", `Evoluciones_${nombrePaciente}.pdf`)}>
              Descargar Evoluciones
            </Button>
            <Button onClick={() => exportarHTML("pdf-medicaciones", `Medicaciones_${nombrePaciente}.pdf`)}>
              Descargar Medicaciones
            </Button>
            <Button onClick={() => exportarHTML("pdf-insumos", `Insumos_${nombrePaciente}.pdf`)}>
              Descargar Insumos
            </Button>
            <Button onClick={() => exportarHTML("pdf-signos", `Signos_${nombrePaciente}.pdf`)}>
              Descargar Signos Vitales
            </Button>
          </div>

          {/* FILTROS */}
          <div className="d-flex gap-3 mb-3 flex-wrap align-items-end">
            <div>
              <label>Desde</label>
              <input type="date" className="form-control" value={fechaDesde} onChange={(e) => setFechaDesde(e.target.value)} />
            </div>

            <div>
              <label>Hasta</label>
              <input type="date" className="form-control" value={fechaHasta} onChange={(e) => setFechaHasta(e.target.value)} />
            </div>

            <div>
              <label>Profesional</label>
              <input
                type="text"
                className="form-control"
                placeholder="Ej: Juan Pérez"
                value={filtroProfesional}
                onChange={(e) => setFiltroProfesional(e.target.value)}
              />
            </div>

            <Button
              variant="danger"
              onClick={() => {
                setFechaDesde("");
                setFechaHasta("");
                setFiltroProfesional("");
              }}
            >
              Limpiar filtros
            </Button>
          </div>

          <Tabs defaultActiveKey="evoluciones">
            <Tab eventKey="evoluciones" title="Evoluciones">
              <Table bordered>
                <tbody>
                  {evolucionesFiltradas.map((e, i) => (
                    <tr key={i}>
                     <td style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
  <div className="d-flex justify-content-between gap-3">
    <div>
      <strong>{e.fechahora} – {e.profesional}</strong>
      <div>{e.texto}</div>
    </div>

    <Button
      size="sm"
      variant="warning"
      onClick={() => {
        setRegistroEditando(e);
        setTipoRegistro("evolucion");
        setShowEditModal(true);
      }}
    >
      <PencilSquare
  size={18}
  
  title="Editar"
  onClick={() => {
    setRegistroEditando(e);
    setTipoRegistro("evolucion");
    setShowEditModal(true);
  }}
/>
    </Button>
  </div>
</td>

                    </tr>
                  ))}
                </tbody>
              </Table>
            </Tab>

            <Tab eventKey="medicaciones" title="Medicaciones">
              <Table bordered>
                <tbody>
                  {medicacionesFiltradas.map((m, i) => (
                    <tr key={i}>
                      <td>
                        <strong>{m.fechaRegistro} – {m.Profesional}</strong>
                        <div>Medicamento: <strong>{m.Medicamento}</strong></div>
                        <div>Dosis: {m.cantidad} {m.unidadMedida}</div>
                        <div>Tipo: {m.tipo}</div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Tab>

            <Tab eventKey="insumos" title="Insumos">
              <Table bordered>
                <tbody>
                  {insumosFiltrados.map((i, k) => (
                    <tr key={k}>
                      <td>
                        <strong>{i.fechahora} – {i.profesional}</strong>
                        <div>Insumo: <strong>{i.insumo}</strong></div>
                        <div>Tipo: {i.tipoinsumo} | Cantidad: {i.cantidad}</div>
                        {i.obs && <div>Observación: {i.obs}</div>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Tab>

            <Tab eventKey="signos" title="Signos Vitales">
              <Table bordered>
                <tbody>
                  {signosFiltrados.map((s, k) => (
                    <tr key={k}>
                      <td>
                        <strong>{s.fechahora} – {s.profesional}</strong>
                        <div>Temp: {s.temperatura} °C | PA: {s.pa}</div>
                        <div>FC: {s.fc} | FR: {s.fr} | SatO₂: {s.sato2}</div>
                        {s.hgt && <div>HGT: {s.hgt}</div>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Tab>
          </Tabs>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="danger" onClick={onCloseModal}>Cerrar</Button>
        </Modal.Footer>
      </Modal>

      {/* ===================== HTML OCULTO PDF ===================== */}
      <div style={{ position: "absolute", left: "-9999px", top: 0 }}>
        {/* EVOLUCIONES */}
        <div id="pdf-evoluciones">
          {chunkArray(evolucionesFiltradas, 6).map((pag, idx, arr) => (
            <div key={idx} style={{ ...pageStyle, pageBreakAfter: idx < arr.length - 1 ? "always" : "auto" }}>
              <div style={headerStyle}><img src={Headerimg} style={{ width: "100%", height: "100%" }} /></div>
              <div style={contentStyle}>
                <h3>Evoluciones</h3>
                <p>{nombrePaciente}</p>
                {pag.map((e, i) => (
                  <div key={i} style={{ marginBottom: "6mm" }}>
                    <strong>{e.fechahora} – {e.profesional}</strong>
                    <div style={{ whiteSpace: "pre-line", textAlign: "justify" }}>
                      {normalizeClinicalText(e.texto)}
                    </div>
                  </div>
                ))}
              </div>
              <div style={footerStyle}><img src={Footerimg} style={{ width: "100%", height: "100%" }} /></div>
            </div>
          ))}
        </div>
      </div>
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Editar registro</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    {tipoRegistro === "evolucion" && (
      <>
        <label>Evolucion: id {registroEditando?.idevolucion}</label>
        <textarea
          className="form-control"
          rows={6}
          value={registroEditando?.texto || ""}
          onChange={(e) =>
            setRegistroEditando({
              ...registroEditando,
              texto: e.target.value,
            })
          }
        />
      </>
    )}

    {tipoRegistro === "medicacion" && (
      <>
        <label>Medicacion: id {registroEditando?.idmedicacion}</label>
        <input
          className="form-control mb-2"
          value={registroEditando?.cantidad || ""}
          onChange={(e) =>
            setRegistroEditando({
              ...registroEditando,
              cantidad: e.target.value,
            })
          }
        />

        <label>Tipo</label>
        <input
          className="form-control"
          value={registroEditando?.tipo || ""}
          onChange={(e) =>
            setRegistroEditando({
              ...registroEditando,
              tipo: e.target.value,
            })
          }
        />
      </>
    )}
  </Modal.Body>

  <Modal.Footer>
    <Button variant="danger" onClick={() => setShowEditModal(false)}>
      Cancelar
    </Button>
    <Button variant="success" onClick={guardarEdicion}>
      Guardar cambios
    </Button>
  </Modal.Footer>
</Modal>

    </>
  );
};

export default ModalHojaEnfermeria;
